export default "__VITE_ASSET__RJb4HsMC__"